(() => {
  'use strict';

  const getRoot = (el) => el && el.closest ? el.closest('[data-pax-product]') : null;

  const activateThumb = (thumb) => {
    const root = getRoot(thumb);
    if (!root) return;

    const main = root.querySelector('.pax-product-stage__image');
    if (!main) return;

    const src = thumb.getAttribute('data-large');
    if (!src) return;

    main.removeAttribute('srcset');
    main.removeAttribute('sizes');
    main.setAttribute('src', src);

    root.querySelectorAll('[data-pax-thumb]').forEach((item) => {
      const active = item === thumb;
      item.classList.toggle('is-active', active);
      item.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
  };

  document.addEventListener('click', (event) => {
    const thumb = event.target.closest && event.target.closest('[data-pax-thumb]');
    if (!thumb) return;

    event.preventDefault();
    activateThumb(thumb);
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Enter' && event.key !== ' ') return;
    const thumb = event.target.closest && event.target.closest('[data-pax-thumb]');
    if (!thumb) return;

    event.preventDefault();
    activateThumb(thumb);
  });

  document.addEventListener('change', (event) => {
    const select = event.target.closest && event.target.closest('[data-pax-variant-select]');
    if (!select) return;

    const root = getRoot(select);
    if (!root) return;

    const option = select.options[select.selectedIndex];
    const mediaId = option && option.getAttribute('data-media-id');
    if (!mediaId) return;

    const thumb = Array.from(root.querySelectorAll('[data-pax-thumb]'))
      .find((item) => item.getAttribute('data-media-id') === mediaId);

    if (thumb) activateThumb(thumb);
  });
})();
